/**
 * 统一收口 fetch
 * 1. 返回永远都是 then 状态 return Promise.resolve({isSuccess,data,errorNo,errorMsg})
 * 2. 推荐使用 await 方式使用
 *    const result = await api.xxx
 *    if(result.isSuccess){ }
 *    else{ }
 * 3. 所有返回格式统一再这里处理，不再使用 fetch fetch1 fetch2
 */
import Fetch from '../utils/fetch';
import { getTujiaHostEnv } from '../tj-utils/env';
import cookies from 'js-cookie';
/**
 * TjFetchRes 为拦截器返回的数据类型，可以不写 data。默认返回数据有 data
 */
var tjFetch = new Fetch({
    resHandle: function (res, options) {
        var resData = {
            isSuccess: false,
            data: null,
            errorNo: 0,
            errorMsg: ''
        };
        // 成功判断
        if (res.ret || res.isSuccess || res.errorCode === 0 || res.errorNo === 0) {
            resData.isSuccess = true;
            resData.data = res.data || res.content || res;
            resData.referTraceId = (res === null || res === void 0 ? void 0 : res.referTraceId) || '';
        }
        else {
            resData.isSuccess = false;
            resData.data = res.data || res.content || res;
            resData.errorNo = res.errorNo || res.errorCode || res.errcode || 'unknown';
            resData.errorMsg =
                res.errorMsg ||
                    res.errorMessage ||
                    res.errmsg ||
                    res.statusText ||
                    res.msg ||
                    'unknown error message';
            resData.host = res.host;
            if (process.env.VUE_ENV !== 'server') {
                apiMonitor(options.url, resData, resData.errorNo);
            }
        }
        return Promise.resolve(resData);
    },
    reqHandle: function (options) {
        // 默认对接口添加当前页面的pid及refpid， 用于前后端日志关联及追踪
        if (window._fas) {
            if (!options.params) {
                options.params = {};
            }
            var _a = window._fas.getGlobalTraceInfo(), pid = _a.pid, refPid = _a.refPid;
            var params = options.params;
            if (!params.pid) {
                params.pid = pid;
            }
            if (!params.refPid) {
                params.refPid = refPid;
            }
        }
    }
});
// 拦截 promise.reject
var originHttp = tjFetch.http;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
tjFetch.http = function (options) {
    return originHttp.call(tjFetch, options).catch(function (err) {
        return Promise.resolve(Object.assign(err, { isSuccess: false }));
    });
};
/**
 * 异常ip监控方法
 * @param {Object} res  接口返回值
 */
function ipMonitor(res) {
    if (res.wafcode === 999 || res.wafcode === 998) {
        if (res.data && res.data.redirectURL) {
            window.location.href = res.data.redirectURL;
        }
    }
    if (res.monitorcode === 999 || res.errorNo === 999) {
        var envInfo = getTujiaHostEnv();
        if (!/pwa\/verify_code/.test(window.location.href)) {
            //
            var currentUrl = window.location.href;
            // 读取cookie中的code
            var code = (cookies === null || cookies === void 0 ? void 0 : cookies.get('tujia_code')) || '';
            // 拼接code到url上
            if (!(currentUrl === null || currentUrl === void 0 ? void 0 : currentUrl.includes('code=')) && code) {
                currentUrl =
                    "".concat(currentUrl + ((currentUrl === null || currentUrl === void 0 ? void 0 : currentUrl.includes('?')) ? '&' : '?')) +
                        "code=".concat(code);
            }
            window.location.replace("https://m".concat(envInfo.isProd ? '' : envInfo.envHostStr, ".tujia.com/pwa/verify_code?returnurl=").concat(encodeURIComponent(currentUrl), "&host=").concat(res.host));
        }
    }
}
/**
 * api 业务异常监控，当成功信息无法正常取到时调用
 * @param {string} url api url
 * @param {Object} res api接口返回值
 * @param {Number} errorNo api错误码
 */
function apiMonitor(url, res, errorNo) {
    if (!res) {
        return;
    }
    try {
        if (res.wafcode) {
            ipMonitor(res);
            setApiBusinessCustomError(url, res, res.wafcode);
        }
        else if (res.monitorcode) {
            ipMonitor(res);
            setApiBusinessCustomError(url, res, res.monitorcode);
        }
        else if (errorNo) {
            if (res.errorNo === 999) {
                ipMonitor(res);
            }
            setApiBusinessCustomError(url, res, errorNo);
        }
    }
    catch (error) {
        console.error(error);
    }
}
/**
 * 设置API错误自定义上报
 * @param {string} url api url
 * @param {Object} res api接口返回值
 * @param {string} errorNo  api error code
 */
function setApiBusinessCustomError(url, res, errorNo) {
    if (!(window._fas && window._fas.setCustomError)) {
        return;
    }
    if (!errorNo ||
        errorNo === '0' ||
        errorNo === 0 ||
        errorNo === -1 ||
        errorNo === -1000) {
        return;
    }
    var apiMsgKey = 'BUSINESS';
    if (errorNo === 1000) {
        apiMsgKey = 'HTTP_STATUS';
    }
    window._fas.setCustomError({
        message: "API ".concat(apiMsgKey, " ERROR: errorCode=").concat(errorNo, " url=").concat(getUrlByRemoveQuerys(url)),
        level: 3,
        error: {
            url: url,
            res: res
        }
    });
}
/**
 * 获取无参数URL
 * @param {string} url URL
 */
function getUrlByRemoveQuerys(url) {
    if (url && url.indexOf('?') > -1) {
        return url.split('?')[0];
    }
    return url;
}
export default tjFetch;
